module.exports = true;


//////////////////
// WEBPACK FOOTER
// ../hyperdb-utils/~/babel-runtime/~/core-js/library/modules/_library.js
// module id = 204
// module chunks = 0